import { fmt } from "@/components/dashboard/util";
import { formatCurrency } from "@/components/pcp";

export const STATUS_LABEL = {
  rascunho: "Rascunho", solicitado: "Solicitado", em_analise: "Em análise", aprovado: "Aprovado (operacional)",
  formalizado: "Formalizado", aplicado: "Aplicado", rejeitado: "Rejeitado", cancelado: "Cancelado",
};
export const STATUS_COR = {
  rascunho: "#78716C", solicitado: "#2563EB", em_analise: "#7C3AED", aprovado: "#D97706", formalizado: "#0F766E", aplicado: "#059669", rejeitado: "#DC2626", cancelado: "#A1A1AA",
};
export const TIPO_LABEL = { revisao_quantitativos: "Revisão de quantitativos", inclusao_item: "Inclusão de item", aditivo: "Aditivo", outro: "Outro procedimento contratual" };
export const ETAPAS = ["rascunho", "solicitado", "em_analise", "aprovado", "formalizado", "aplicado"];

export function StatusChip({ status }) {
  return (
    <span data-testid={`reprog-status-${status}`} style={{ display: "inline-block", padding: "2px 8px", borderRadius: 999, fontSize: "0.68rem", fontWeight: 700, letterSpacing: "0.04em", textTransform: "uppercase", color: "#fff", background: STATUS_COR[status] || "#78716C" }}>
      {STATUS_LABEL[status] || status}
    </span>
  );
}

export function Money({ v, neg, testid }) {
  return <span className="font-mono" data-testid={testid} style={{ color: neg && v > 0 ? "#DC2626" : undefined }}>{formatCurrency(v || 0)}</span>;
}

export const q = (v, d = 2) => fmt(v || 0, d);
